import React from "react";


export default function TwoColumnLayout({ children }) {
const [leftChild, rightChild] = React.Children.toArray(children);


  return (
<div className="right-colum-layout">
      <div className="inner-left-column"> 
           {leftChild}
      </div>

      <div className="inner-right-column"> 
            {rightChild}
      </div>
</div>
    
  );


}
